import { useEffect, useRef } from "react"
import Card from '@heruka_urgyen/react-playing-cards/lib/TcN'
import { useDispatch, useSelector } from "react-redux"
import { drawACard, updateGameStateFromFirestore } from "../../services/gameService"
import { doc, getFirestore, onSnapshot } from "firebase/firestore"

const Room = () => {
  const db = getFirestore()
  const game = useSelector(state => state.game)
  const user = useSelector(state => state.user)
  const cards = useSelector(state => state.game.players[user.uid].cards)
  const gameRef = doc(db, "games", game.id)
  const dispatch = useDispatch()
  const focusRef = useRef(null)

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    const unsubGame = onSnapshot(doc(db, "games", game.id), async (doc) => {
      const source = doc.metadata.hasPendingWrites ? "Local" : "Server"
      if (source === 'Local') return

      await updateGameStateFromFirestore(db, game.id, dispatch)
    })

  }, [db, dispatch, game.id])

  useEffect(() => {
    focusRef.current.addEventListener('keydown', (e) => {
      console.log(e.code)
    }, false)
  }, [])

  const discardCard = async (playerUID) => {
    if (playerUID === user.uid) drawACard(playerUID, gameRef, cards, dispatch)
    focusRef.current.focus()
  }

  return (
    <div>
      <div>room</div>

      <div className="">
        <div className="">
          {
            Object.keys(game.players).map(
              (player, i) => {
                if (player === user.uid) {
                  return (
                    <div className="player" key={player} style={{ display: 'inline-block', marginRight: '1em' }}>
                      <div className="card-holder" style={{ height: '5em' }}>
                        {
                          cards.map(
                            (card) => <div key={card} style={{ display: 'inline-block', position: 'absolute' }} className="card" onClick={() => discardCard(player)}>
                              <Card card={card} height="5em"></Card></div>
                          )
                        }
                      </div>
                      <div>{game.players[player].displayName.split('').splice(0, 7).join('')}{` (${game.players[player].remainingCards})`}</div>
                    </div>
                  )
                } else {
                  return (
                    <div className="player" key={player} style={{ display: 'inline-block', marginRight: '1em' }}>
                      <div className="card-holder" style={{ height: '5em' }}>
                        <Card back card="4s" height="5em"></Card>
                      </div>
                      <div>{game.players[player].displayName.split('').splice(0, 7).join('')}{` (${game.players[player].remainingCards})`}</div>
                    </div>
                  )
                }
              }
            )
          }
        </div>

        <div tabIndex="0" ref={focusRef}>
          {game.drawPile.length === 0 ? '' : `Hit key: ${game.drawPile.slice(-1)[0][0]}`}
        </div>
        <div>
          <div className="discard" style={{ position: 'relative' }}>
            {
              game.drawPile.map((card, i) => {
                return (<div key={card} style={{ position: 'absolute', left: `${i * 0.5}em` }} className="card-holder">
                  <Card card={card} height="5em" ></Card>
                </div>)
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Room